import { render, staticRenderFns } from "./FinishedTaskDocument.vue?vue&type=template&id=2f4c0514&"
import script from "./FinishedTaskDocument.vue?vue&type=script&lang=js&"
export * from "./FinishedTaskDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports